import avatarManager from './avatar-manager';
import fileManager from './file-manager';
import flashPlugin from "@plugins/flash";
import holidays from "@plugins/holidays";

export default {
  avatarManager,
  fileManager,
  flashPlugin,
  holidays
}
